// @flow
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Loadable from 'react-loadable'
import ReduxToastr from 'react-redux-toastr'

import { AxinanShow, AxinanLogo } from '../../components/Axinan'
import Header from '../Header'
import PrivateRoute from '../PrivateRoute'

import logo from './logo.svg'
import './styles.css'

const LoadableLogin = Loadable({
  loader: () => import('../Login'),
  loading: AxinanShow,
})

const LoadableWarehouse = Loadable({
  loader: () => import('../Warehouse'),
  loading: AxinanShow,
})

const LoadableMerchant = Loadable({
  loader: () => import('../Merchant'),
  loading: AxinanShow,
})

const LoadableReturnDetails = Loadable({
  loader: () => import('../ReturnDetails'),
  loading: AxinanShow,
})

const LoadableCustomerService = Loadable({
  loader: () => import('../CustomerService'),
  loading: AxinanShow,
})

const LoadableWarehouseRecord = Loadable({
  loader: () => import('../WarehouseRecord'),
  loading: AxinanShow,
})

const LoadableNoPermission = Loadable({
  loader: () => import('../NoPermission'),
  loading: AxinanShow,
})

const Loadable404Page = Loadable({
  loader: () => import('../404'),
  loading: AxinanShow,
})

const LoadableChangePassword = Loadable({
  loader: () => import('../ChangePassword'),
  loading: AxinanShow,
})

const LoadableGeneralReturnDetails = Loadable({
  loader: () => import('../GeneralReturnDetails'),
  loading: AxinanShow,
})

const LoadableResellBeta = Loadable({
  loader: () => import('../ResellBeta'),
  loading: AxinanShow,
})

const LoadableResellBetaDetails = Loadable({
  loader: () => import('../ResellBetaDetails'),
  loading: AxinanShow,
})

const LoadableStockIn = Loadable({
  loader: () => import('../StockIn'),
  loading: AxinanShow,
})

const LoadableUnreceivedPackages = Loadable({
  loader: () => import('../UnreceivedPackages'),
  loading: AxinanShow,
})

const LoadableStagingRecordList = Loadable({
  loader: () => import('../StagingRecordList'),
  loading: AxinanShow,
})
// <PrivateRoute allow={['cs', 'admin', 'warehouse']} path="/stock-in" component={LoadableStockIn} />
// <Route path="/stock-in" component={LoadableStockIn} />
const App = () => (
  <div className="App">
    <Header />
    <AxinanLogo />
    <Switch>
    <Route exact path="/login" component={LoadableLogin} />
    <Route exact path="/" component={LoadableLogin} />
    <PrivateRoute allow={'warehouse'} path="/warehouse" component={LoadableWarehouse} />
    <PrivateRoute exact allow={'merchant'} path="/merchant" component={LoadableMerchant} />
    <PrivateRoute allow={['cs', 'zhongan', 'admin']} path="/customer-service/:partner/:tab?/:page?" component={LoadableCustomerService} />
    <PrivateRoute exact allow={['cs', 'merchant', 'admin']} path="/return-request/:returnId" component={LoadableReturnDetails} />
    <PrivateRoute allow={['cs', 'admin']} path="/warehouse-record/:recordId" component={LoadableWarehouseRecord} />
    <PrivateRoute allow={['cs', 'zhongan', 'admin', 'warehouse']} path="/policy-details/:policyId" component={LoadableGeneralReturnDetails} />
    <PrivateRoute allow={['cs', 'merchant', 'warehouse', 'zhongan', 'admin']} path="/change-password" component={LoadableChangePassword} />
    <PrivateRoute allow={['cs', 'admin']} path="/resell-beta/:page?" component={LoadableResellBeta} />
    <PrivateRoute allow={['cs', 'admin']} path="/resell-details/:coverageId" component={LoadableResellBetaDetails} />
    <PrivateRoute allow={['cs', 'admin', 'warehouse']} path="/staging-records/:warehouseId?" component={LoadableStagingRecordList} />
    <PrivateRoute allow={['cs', 'admin', 'warehouse']} path="/stock-in/:trackingNumber?" component={LoadableStockIn} />
    <PrivateRoute allow={['cs', 'admin', 'warehouse']} path="/unreceived-packages/:page?" component={LoadableUnreceivedPackages} />
    <Route path="/no-permission" component={LoadableNoPermission} />
    <Route path="*" component={Loadable404Page} />
    </Switch>
    <ReduxToastr
      timeOut={30000}
      newestOnTop={false}
      preventDuplicates
      position="top-right"
      transitionIn="fadeIn"
      transitionOut="fadeOut"
      progressBar
    />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js